// src/content/packages.js
export const whatsapp = "62812xxxxxxx"; // ganti nomor WA

const packages = [
  {
    brand: "Hikvision",
    slug: "hikvision",
    logo: "/brands/hikvision.png",
    cover: "/packages/hikvision/cover.jpg",
    summary:
      "Paket analog & IP dengan kualitas stabil, cocok untuk rumah & ruko.",
    startFrom: 4400000,
    categories: [
      {
        name: "Paket CCTV Hikvision 2 MP",
        slug: "paket-cctv-hikvision-2-mp",
        theme: "blue",
        items: [
          {
            title: "Paket 1 Kamera Hikvision 2 MP",
            price: 2471000,
            img: "/packages/hikvision/paket1-hikvision-2mp.png",
            features: [
              "1 pcs Indoor Hikvision DS-2CE76D0T-EXIPF (boleh di tukar kamera Outdoor)",
              "1 pcs DVR 4 Ch Hikvision DS-7204HQHI-K1/E",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 15 mtr Kabel RG 59",
              "2 pcs Konektor BNC",
              "1 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 2 Kamera Hikvision 2 MP",
            price: 3073000,
            img: "/packages/hikvision/paket2-hikvision-2mp.png",
            features: [
              "1 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "1 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 4 Ch Hikvision DS-7204HQHI-K1/E",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 40 mtr Kabel RG 59",
              "4 pcs Konektor BNC",
              "2 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 3 Kamera Hikvision 2 MP",
            price: 3657000,
            img: "/packages/hikvision/paket3-hikvision-2mp.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "1 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 4 Ch Hikvision DS-7204HQHI-K1/E",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 60 mtr Kabel RG 59",
              "6 pcs Konektor BNC",
              "3 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 4 Kamera Hikvision 2 MP",
            price: 4463000,
            img: "/packages/hikvision/paket4-hikvision-2mp.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "2 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 4 Ch Hikvision DS-7204HQHI-K1/E",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 120 mtr Kabel RG 59",
              "8 pcs Konektor BNC",
              "4 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 5 Kamera Hikvision 2 MP",
            price: 6295000,
            img: "/packages/hikvision/paket5-hikvision-2mp.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "2 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 8 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 150 mtr Kabel RG 59",
              "10 pcs Konektor BNC",
              "5 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 6 Kamera Hikvision 2 MP",
            price: 6958000,
            img: "/packages/hikvision/paket6-hikvision-2mp.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "3 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 8 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 180 mtr Kabel RG 59",
              "12 pcs Konektor BNC",
              "6 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "3 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 7 Kamera Hikvision 2 MP",
            price: 7612000,
            img: "/packages/hikvision/paket7-hikvision-2mp.png",
            features: [
              "4 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "3 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 8 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 210 mtr Kabel RG 59",
              "14 pcs Konektor BNC",
              "7 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "4 bks Klem No.12",
              " 1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 8 Kamera Hikvision 2 MP",
            price: 8246000,
            img: "/packages/hikvision/paket8-hikvision-2mp.png",
            features: [
              "5 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "3 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 8 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 240 mtr Kabel RG 59",
              "16 pcs Konektor BNC",
              "8 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "5 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 10 Kamera Hikvision 2 MP",
            price: 11531000,
            img: "/packages/hikvision/paket10-hikvision-2mp.png",
            features: [
              "6 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "4 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 16 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 300 mtr Kabel RG 59",
              "20 pcs Konektor BNC",
              "10 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "4 bks Klem No.9",
              "6 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 12 Kamera Hikvision 2 MP",
            price: 12804000,
            img: "/packages/hikvision/paket12-hikvision-2mp.png",
            features: [
              "8 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "4 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 16 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 360 mtr Kabel RG 59",
              "24 pcs Konektor BNC",
              "12 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "8 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 14 Kamera Hikvision 2 MP",
            price: 14124000,
            img: "/packages/hikvision/paket14-hikvision-2mp.png",
            features: [
              "9 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "5 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 16 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 420 mtr Kabel RG 59",
              "28 pcs Konektor BNC",
              "14 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "9 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 16 Kamera Hikvision 2 MP",
            price: 15519000,
            img: "/packages/hikvision/paket16-hikvision-2mp.png",
            features: [
              "10 pcs Indoor Hikvision DS-2CE76D0T-EXIPF",
              "6 pcs Outdoor Hikvision DS-2CE16D0T-EXIPF",
              "1 pcs DVR 16 Ch Hikvision DS-7208HQHI-K1/E",
              "1 pcs Hardisk WD Purpe 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 500 mtr Kabel RG 59",
              "32 pcs Konektor BNC",
              "16 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "6 bks Klem No.9",
              "10 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
      {
        name: "Paket CCTV Hikvision 2 MP Smart Light",
        slug: "paket-cctv-hikvision-2-mp-smart-light",
        theme: "blue",
        items: [
          {
            title: "Paket 1 Kamera Hikvision 2 MP",
            price: 2693000,
            img: "/packages/hikvision/paket1-hikvision-2mp-sl.png",
            features: [
              "1 pcs Indoor / Outdoor Hikvision DS-2CE76DOT-EXLPF",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 15 mtr Kabel RG 59",
              "2 pcs Konektor BNC",
              "1 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 2 Kamera Hikvision 2 MP",
            price: 3340000,
            img: "/packages/hikvision/paket2-hikvision-2mp-sl.png",
            features: [
              "1 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "1 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 40 mtr Kabel RG 59",
              "4 pcs Konektor BNC",
              "2 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 3 Kamera Hikvision 2 MP",
            price: 3969000,
            img: "/packages/hikvision/paket3-hikvision-2mp-sl.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "1 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 60 mtr Kabel RG 59",
              "6 pcs Konektor BNC",
              "3 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 4 Kamera Hikvision 2 MP",
            price: 4828000,
            img: "/packages/hikvision/paket4-hikvision-2mp-sl.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "2 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 120 mtr Kabel RG 59",
              "8 pcs Konektor BNC",
              "4 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 5 Kamera Hikvision 2 MP",
            price: 6836000,
            img: "/packages/hikvision/paket5-hikvision-2mp-sl.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "2 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 150 mtr Kabel RG 59",
              "10 pcs Konektor BNC",
              "5 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 6 Kamera Hikvision 2 MP",
            price: 7552000,
            img: "/packages/hikvision/paket6-hikvision-2mp-sl.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "3 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 180 mtr Kabel RG 59",
              "12 pcs Konektor BNC",
              "6 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "3 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 7 Kamera Hikvision 2 MP",
            price: 8251000,
            img: "/packages/hikvision/paket7-hikvision-2mp-sl.png",
            features: [
              "4 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "3 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 210 mtr Kabel RG 59",
              "14 pcs Konektor BNC",
              "7 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "4 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 8 Kamera Hikvision 2 MP",
            price: 8930000,
            img: "/packages/hikvision/paket8-hikvision-2mp-sl.png",
            features: [
              "5 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "3 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 240 mtr Kabel RG 59",
              "16 pcs Konektor BNC",
              "8 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "5 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 10 Kamera Hikvision 2 MP",
            price: 12763000,
            img: "/packages/hikvision/paket10-hikvision-2mp-sl.png",
            features: [
              "6 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "4 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 300 mtr Kabel RG 59",
              "20 pcs Konektor BNC",
              "10 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "4 bks Klem No.9",
              "6 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 12 Kamera Hikvision 2 MP",
            price: 14126000,
            img: "/packages/hikvision/paket12-hikvision-2mp-sl.png",
            features: [
              "8 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "4 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 360 mtr Kabel RG 59",
              "24 pcs Konektor BNC",
              "12 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "8 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 14 Kamera Hikvision 2 MP",
            price: 15544000,
            img: "/packages/hikvision/paket14-hikvision-2mp-sl.png",
            features: [
              "9 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "5 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 420 mtr Kabel RG 59",
              "28 pcs Konektor BNC",
              "14 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "9 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 16 Kamera Hikvision 2 MP",
            price: 17037000,
            img: "/packages/hikvision/paket16-hikvision-2mp-sl.png",
            features: [
              "10 pcs Indoor Hikvision DS-2CE76DOT-EXLPF",
              "6 pcs Outdoor Hikvision DS-2CE16DOT-EXLPF",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 500 mtr Kabel RG 59",
              "28 pcs Konektor BNC",
              "14 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "6 bks Klem No.9",
              "10 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
      {
        name: "Paket CCTV Hikvision 2 MP Smart Light Audio",
        slug: "paket-cctv-hikvision-2-mp-smart-light-audio",
        theme: "blue",
        items: [
          {
            title: " Paket 1 Kamera Hikvision 2 MP Audio",
            price: 2785000,
            img: "/packages/hikvision/paket1-hikvision-2mp-sl-audio.png",
            features: [
              "1 pcs Indoor / Outdoor Hikvision DS-2CE76D0T-LPFS",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 15 mtr Kabel RG 59",
              "2 pcs Konektor BNC",
              "1 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: " Paket 2 Kamera Hikvision 2 MP Audio",
            price: 3529000,
            img: "/packages/hikvision/paket2-hikvision-2mp-sl-audio.png",
            features: [
              "1 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "1 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 40 mtr Kabel RG 59",
              "4 pcs Konektor BNC",
              "2 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: " Paket 3 Kamera Hikvision 2 MP Audio",
            price: 4255000,
            img: "/packages/hikvision/paket3-hikvision-2mp-sl-audio.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "1 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 60 mtr Kabel RG 59",
              "6 pcs Konektor BNC",
              "3 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: " Paket 4 Kamera Hikvision 2 MP Audio",
            price: 5206000,
            img: "/packages/hikvision/paket4-hikvision-2mp-sl-audio.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "2 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 4 Ch Hikvision iDS-7204HQHI-M1/XT",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 120 mtr Kabel RG 59",
              "8 pcs Konektor BNC",
              "4 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 5 Kamera Hikvision 2 MP Audio",
            price: 7311000,
            img: "/packages/hikvision/paket5-hikvision-2mp-sl-audio.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "2 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 150 mtr Kabel RG 59",
              "10 pcs Konektor BNC",
              "5 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 6 Kamera Hikvision 2 MP Audio",
            price: 8119000,
            img: "/packages/hikvision/paket6-hikvision-2mp-sl-audio.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "3 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 180 mtr Kabel RG 59",
              "12 pcs Konektor BNC",
              "6 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "3 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 7 Kamera Hikvision 2 MP Audio",
            price: 8915000,
            img: "/packages/hikvision/paket7-hikvision-2mp-sl-audio.png",
            features: [
              "4 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "3 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 210 mtr Kabel RG 59",
              "14 pcs Konektor BNC",
              "7 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "4 bks Klem No.12",
              " 1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 8 Kamera Hikvision 2 MP Audio",
            price: 9691000,
            img: "/packages/hikvision/paket8-hikvision-2mp-sl-audio.png",
            features: [
              "5 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "3 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 8 Ch Hikvision iDS-7208HQHI-M1/XT",
              "1 pcs Hardisk WD Purpe 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 240 mtr Kabel RG 59",
              "16 pcs Konektor BNC",
              "8 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "5 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 10 Kamera Hikvision 2 MP Audio",
            price: 13713000,
            img: "/packages/hikvision/paket10-hikvision-2mp-sl-audio.png",
            features: [
              "6 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "4 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 300 mtr Kabel RG 59",
              "20 pcs Konektor BNC",
              "10 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "4 bks Klem No.9",
              "6 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 12 Kamera Hikvision 2 MP Audio",
            price: 15270000,
            img: "/packages/hikvision/paket12-hikvision-2mp-sl-audio.png",
            features: [
              "8 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "4 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 360 mtr Kabel RG 59",
              "24 pcs Konektor BNC",
              "12 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "8 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 14 Kamera Hikvision 2 MP Audio",
            price: 16877000,
            img: "/packages/hikvision/paket14-hikvision-2mp-sl-audio.png",
            features: [
              "9 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "5 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 420 mtr Kabel RG 59",
              "28 pcs Konektor BNC",
              "14 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "9 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },{
            title: "Paket 16 Kamera Hikvision 2 MP Audio",
            price: 18559000,
            img: "/packages/hikvision/paket16-hikvision-2mp-sl-audio.png",
            features: [
              "10 pcs Indoor Hikvision DS-2CE76D0T-LPFS",
              "6 pcs Outdoor Hikvision DS-2CE16D0T-LPFS",
              "1 pcs DVR 16 Ch Hikvision iDS-7216HQHI-M1/XT",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 500 mtr Kabel RG 59",
              "32 pcs Konektor BNC",
              "16 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "6 bks Klem No.9",
              "10 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
      {
        name: "Paket CCTV IP Camera Hikvision 2 MP ColorVu",
        slug: "paket-cctv-ip-camera-hikvision-2-mp-colorvu",
        theme: "blue",
        items: [
          {
            title: "Paket 1 IP Camera Hikvision 2 MP ColorVu",
            price: 4616000,
            img: "/packages/hikvision/paket1-hikvision-2mp-colorvu.png",
            features: [
              "1 pcs Indoor Hikvision DS-2CD1127G2-L",
              "(Kamera Indoor boleh tukar Outdoor)",
              "1 pcs NVR 4 Ch Hikvision DS-7604NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0106P-E/M",
              "Max. 15 mtr Kabel UTP CAT 6 Hikvision",
              "4 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 2 IP Camera Hikvision 2 MP ColorVu",
            price: 6222000,
            img: "/packages/hikvision/paket2-hikvision-2mp-colorvu.png",
            features: [
              "1 pcs Indoor Hikvision DS-2CD1127G2-L",
              "1 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 4 Ch Hikvision DS-7604NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0106P-E/M",
              "Max. 40 mtr Kabel UTP CAT 6 Hikvision",
              "6 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 3 IP Camera Hikvision 2 MP ColorVu",
            price: 7785000,
            img: "/packages/hikvision/paket3-hikvision-2mp-colorvu.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CD1127G2-L",
              "1 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 4 Ch Hikvision DS-7604NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0106P-E/M",
              "Max. 60 mtr Kabel UTP CAT 6 Hikvision",
              "8 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 4 IP Camera Hikvision 2 MP ColorVu",
            price: 9601000,
            img: "/packages/hikvision/paket4-hikvision-2mp-colorvu.png",
            features: [
              "2 pcs Indoor Hikvision DS-2CD1127G2-L",
              "2 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 4 Ch Hikvision DS-7604NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0106P-E/M",
              "Max. 120 mtr Kabel UTP CAT 6 Hikvision",
              "10 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 5 IP Camera Hikvision 2 MP ColorVu",
            price: 11902000,
            img: "/packages/hikvision/paket5-hikvision-2mp-colorvu.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CD1127G2-L",
              "2 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 8 Ch Hikvision DS-7608NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 150 mtr Kabel UTP CAT 6 Hikvision",
              "14 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "2 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 6 IP Camera Hikvision 2 MP ColorVu",
            price: 13425000,
            img: "/packages/hikvision/paket6-hikvision-2mp-colorvu.png",
            features: [
              "3 pcs Indoor Hikvision DS-2CD1127G2-L",
              "3 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 8 Ch Hikvision DS-7608NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 180 mtr Kabel UTP CAT 6 Hikvision",
              "16 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "2 bks Klem No.9",
              "3 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 7 IP Camera Hikvision 2 MP ColorVu",
            price: 15108000,
            img: "/packages/hikvision/paket7-hikvision-2mp-colorvu.png",
            features: [
              "4 pcs Indoor Hikvision DS-2CD1127G2-L",
              "3 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 8 Ch Hikvision DS-7608NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 210 mtr Kabel UTP CAT 6 Hikvision",
              "18 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "2 bks Klem No.9",
              "4 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 8 IP Camera Hikvision 2 MP ColorVu",
            price: 16771000,
            img: "/packages/hikvision/paket8-hikvision-2mp-colorvu.png",
            features: [
              "5 pcs Indoor Hikvision DS-2CD1127G2-L",
              "3 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 8 Ch Hikvision DS-7608NI-Q1",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "1 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 240 mtr Kabel UTP CAT 6 Hikvision",
              "20 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "2 bks Klem No.9",
              "5 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 10 IP Camera Hikvision 2 MP ColorVu",
            price: 22077000,
            img: "/packages/hikvision/paket10-hikvision-2mp-colorvu.png",
            features: [
              "6 pcs Indoor Hikvision DS-2CD1127G2-L",
              "4 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 16 Ch Hikvision DS-7616NI-Q2",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "2 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 300 mtr Kabel UTP CAT 6 Hikvision",
              "24 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "4 bks Klem No.9",
              "6 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 12 IP Camera Hikvision 2 MP ColorVu",
            price: 25408000,
            img: "/packages/hikvision/paket12-hikvision-2mp-colorvu.png",
            features: [
              "8 pcs Indoor Hikvision DS-2CD1127G2-L",
              "4 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 16 Ch Hikvision DS-7616NI-Q2",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "2 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 360 mtr Kabel UTP CAT 6 Hikvision",
              "28 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "5 bks Klem No.9",
              "8 bks Klem No.12",
              "1 bks Klem No. 17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 14 IP Camera Hikvision 2 MP ColorVu",
            price: 28617000,
            img: "/packages/hikvision/paket14-hikvision-2mp-colorvu.png",
            features: [
              "9 pcs Indoor Hikvision DS-2CD1127G2-L",
              "5 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 16 Ch Hikvision DS-7616NI-Q2",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "2 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 420 mtr Kabel UTP CAT 6 Hikvision",
              "32 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "5 bks Klem No.9",
              "9 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 16 IP Camera Hikvision 2 MP ColorVu",
            price: 32001000,
            img: "/packages/hikvision/paket16-hikvision-2mp-colorvu.png",
            features: [
              "10 pcs Indoor Hikvision DS-2CD1127G2-L",
              "6 pcs Outdoor Hikvision DS-2CD1027G2-L",
              "1 pcs NVR 16 Ch Hikvision DS-7616NI-Q2",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs Switch Hub Hikvision DS-3E0505D-E",
              "2 pcs Switch POE Hikvision DS-3E0310P-E/M",
              "Max. 500 mtr Kabel UTP CAT 6 Hikvision",
              "36 pcs Konektor RJ 45",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "2 pcs UTP Pendek",
              "6 bks Klem No.9",
              "10 bks Klem No.12",
              "2 bks Klem No. 17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
    ],
  },

  {
    brand: "HiLook",
    slug: "hilook",
    logo: "/brands/hilook.png",
    cover: "/packages/hilook/cover.jpg",
    summary: "Sub-brand Hikvision, harga ramah & kualitas teruji.",
    startFrom: 3990000,
    categories: [
      {
        name: "Paket CCTV Hilook 2 MP Audio  - Garansi 1 Tahun",
        slug: "paket-cctv-hilook-2-mp-audio-garansi-1-tahun",
        theme: "blue",
        items: [
          {
            title: "Paket 1 Kamera Hilook 2 MP Audio",
            price: 1746000,
            img: "/packages/hilook/paket1-hilook2mp-audio.png",
            features: [
              "1 pcs Indoor Hilook THC-T120-PS (boleh di tukar kamera Outdoor)",
              "1 pcs DVR 4 Channel Hilook 204G-M1/T",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 15 mtr Kabel RG 59",
              "2 pcs Konektor BNC",
              "1 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 2 Kamera Hilook 2 MP Audio",
            price: 2297000,
            img: "/packages/hilook/paket2-hilook2mp-audio.png",
            features: [
              "1 pcs Indoor Hilook THC-T120-PS",
              "1 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 4 Channel Hilook 204G-M1/T",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 40 mtr Kabel RG 59",
              "4 pcs Konektor BNC",
              "2 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 3 Kamera Hilook 2 MP Audio",
            price: 2830000,
            img: "/packages/hilook/paket3-hilook2mp-audio.png",
            features: [
              "2 pcs Indoor Hilook THC-T120-PS",
              "1 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 4 Channel Hilook 204G-M1/T",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 60 mtr Kabel RG 59",
              "6 pcs Konektor BNC",
              "3 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 4 Kamera Hilook 2 MP Audio",
            price: 3582000,
            img: "/packages/hilook/paket4-hilook2mp-audio.png",
            features: [
              "2 pcs Indoor Hilook THC-T120-PS",
              "2 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 4 Channel Hilook 204G-M1/T",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 120 mtr Kabel RG 59",
              "8 pcs Konektor BNC",
              "4 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 5 Kamera Hilook 2 MP Audio",
            price: 4812000,
            img: "/packages/hilook/paket5-hilook2mp-audio.png",
            features: [
              "3 pcs Indoor Hilook THC-T120-PS",
              "2 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 8 Channel Hilook 208G-M1/T",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 150 mtr Kabel RG 59",
              "10 pcs Konektor BNC",
              "5 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 6 Kamera Hilook 2 MP Audio",
            price: 5421000,
            img: "/packages/hilook/paket6-hilook2mp-audio.png",
            features: [
              "3 pcs Indoor Hilook THC-T120-PS",
              "3 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 8 Channel Hilook 208G-M1/T",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 180 mtr Kabel RG 59",
              "12 pcs Konektor BNC",
              "6 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "3 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 7 Kamera Hilook 2 MP Audio",
            price: 6024000,
            img: "/packages/hilook/paket7-hilook2mp-audio.png",
            features: [
              "4 pcs Indoor Hilook THC-T120-PS",
              "3 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 8 Channel Hilook 208G-M1/T",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 210 mtr Kabel RG 59",
              "14 pcs Konektor BNC",
              "7 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "4 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 8 Kamera Hilook 2 MP Audio",
            price: 6607000,
            img: "/packages/hilook/paket8-hilook2mp-audio.png",
            features: [
              "5 pcs Indoor Hilook THC-T120-PS",
              "3 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 8 Channel Hilook 208G-M1/T",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 240 mtr Kabel RG 59",
              "16 pcs Konektor BNC",
              "8 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "5 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 10 Kamera Hilook 2 MP Audio",
            price: 8787000,
            img: "/packages/hilook/paket10-hilook2mp-audio.png",
            features: [
              "6 pcs Indoor Hilook THC-T120-PS",
              "4 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 16 Channel Hilook 216G-M1/T",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 300 mtr Kabel RG 59",
              "20 pcs Konektor BNC",
              "10 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "4 bks Klem No.9",
              "6 bks Klem No.12",
              "1 bks Klem No.17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 12 Kamera Hilook 2 MP Audio",
            price: 9958000,
            img: "/packages/hilook/paket12-hilook2mp-audio.png",
            features: [
              "8 pcs Indoor Hilook THC-T120-PS",
              "4 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 16 Channel Hilook 216G-M1/T",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 360 mtr Kabel RG 59",
              "24 pcs Konektor BNC",
              "12 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "8 bks Klem No.12",
              "1 bks Klem No.17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 14 Kamera Hilook 2 MP Audio",
            price: 11173000,
            img: "/packages/hilook/paket14-hilook2mp-audio.png",
            features: [
              "9 pcs Indoor Hilook THC-T120-PS",
              "5 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 16 Channel Hilook 216G-M1/T",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 420 mtr Kabel RG 59",
              "28 pcs Konektor BNC",
              "14 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "9 bks Klem No.12",
              "2 bks Klem No.17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 16 Kamera Hilook 2 MP Audio",
            price: 12463000,
            img: "/packages/hilook/paket16-hilook2mp-audio.png",
            features: [
              "10 pcs Indoor Hilook THC-T120-PS",
              "6 pcs Outdoor Hilook THC-B120-PS",
              "1 pcs DVR 16 Channel Hilook 216G-M1/T",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 500 mtr Kabel RG 59",
              "32 pcs Konektor BNC",
              "16 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "6 bks Klem No.9",
              "10 bks Klem No.12",
              "2 bks Klem No.17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
      {
        name: "Paket CCTV Hilook 2 MP",
        slug: "paket-cctv-hilook-2-mp",
        theme: "blue",
        items: [
          {
            title: "Paket 1 Kamera Hilook 2 MP",
            price: 1940000,
            img: "/packages/hilook/paket1-hilook2mp.png",
            features: [
              "1 pcs Indoor Hilook THC-T120-PC (boleh di tukar kamera Outdoor)",
              "1 pcs DVR 4 Channel Hilook 204G-F1(s)",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 15 mtr Kabel RG 59",
              "2 pcs Konektor BNC",
              "1 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 2 Kamera Hilook 2 MP",
            price: 2458000,
            img: "/packages/hilook/paket2-hilook2mp.png",
            features: [
              "1 pcs Indoor Hilook THC-T120-PC (boleh di tukar kamera Outdoor)",
              "1 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 4 Channel Hilook 204G-F1(s)",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 40 mtr Kabel RG 59",
              "4 pcs Konektor BNC",
              "2 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "1 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 3 Kamera Hilook 2 MP",
            price: 2958000,
            img: "/packages/hilook/paket3-hilook2mp.png",
            features: [
              "2 pcs Indoor Hilook THC-T120-PC",
              "1 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 4 Channel Hilook 204G-F1(s)",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 60 mtr Kabel RG 59",
              "6 pcs Konektor BNC",
              "3 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 4 Kamera Hilook 2 MP",
            price: 3671000,
            img: "/packages/hilook/paket4-hilook2mp.png",
            features: [
              "2 pcs Indoor Hilook THC-T120-PC",
              "2 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 4 Channel Hilook 204G-F1(s)",
              "1 pcs Hardisk Seagate 500 GB",
              "1 pcs PSU 12 Volt 10 Amp",
              "Max. 120 mtr Kabel RG 59",
              "8 pcs Konektor BNC",
              "4 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "1 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 25",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 5 Kamera Hilook 2 MP",
            price: 4979000,
            img: "/packages/hilook/paket5-hilook2mp.png",
            features: [
              "3 pcs Indoor Hilook THC-T120-PC",
              "2 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 8 Channel Hilook 208G-F1(s)",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 150 mtr Kabel RG 59",
              "10 pcs Konektor BNC",
              "5 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "2 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 6 Kamera Hilook 2 MP",
            price: 5549000,
            img: "/packages/hilook/paket6-hilook2mp.png",
            features: [
              "3 pcs Indoor Hilook THC-T120-PC",
              "3 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 8 Channel Hilook 208G-F1(s)",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 180 mtr Kabel RG 59",
              "12 pcs Konektor BNC",
              "6 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "3 bks Klem No.12",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 7 Kamera Hilook 2 MP",
            price: 6119000,
            img: "/packages/hilook/paket7-hilook2mp.png",
            features: [
              "4 pcs Indoor Hilook THC-T120-PC",
              "3 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 8 Channel Hilook 208G-F1(s)",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 210 mtr Kabel RG 59",
              "14 pcs Konektor BNC",
              "7 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "4 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 8 Kamera Hilook 2 MP",
            price: 6669000,
            img: "/packages/hilook/paket8-hilook2mp.png",
            features: [
              "5 pcs Indoor Hilook THC-T120-PC",
              "3 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 8 Channel Hilook 208G-F1(s)",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs PSU 12 Volt 20 Amp",
              "Max. 240 mtr Kabel RG 59",
              "16 pcs Konektor BNC",
              "8 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "2 bks Klem No.9",
              "5 bks Klem No.12",
              "1 bks Kabel Ties",
              "Kabel Duct 25 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 10 Kamera Hilook 2 MP",
            price: 8962000,
            img: "/packages/hilook/paket10-hilook2mp.png",
            features: [
              "6 pcs Indoor Hilook THC-T120-PC",
              "4 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 16 Channel Hilook 216G-K1(s)",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 300 mtr Kabel RG 59",
              "20 pcs Konektor BNC",
              "10 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "4 bks Klem No.9",
              "6 bks Klem No.12",
              "1 bks Klem No.17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 12 Kamera Hilook 2 MP",
            price: 10067000,
            img: "/packages/hilook/paket12-hilook2mp.png",
            features: [
              "8 pcs Indoor Hilook THC-T120-PC",
              "4 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 16 Channel Hilook 216G-K1(s)",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 360 mtr Kabel RG 59",
              "24 pcs Konektor BNC",
              "12 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "8 bks Klem No.12",
              "1 bks Klem No.17",
              "1 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 14 Kamera Hilook 2 MP",
            price: 11210000,
            img: "/packages/hilook/paket14-hilook2mp.png",
            features: [
              "9 pcs Indoor Hilook THC-T120-PC",
              "5 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 16 Channel Hilook 216G-K1(s)",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 420 mtr Kabel RG 59",
              "28 pcs Konektor BNC",
              "14 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "5 bks Klem No.9",
              "9 bks Klem No.12",
              "2 bks Klem No.17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Paket 16 Kamera Hilook 2 MP Audio",
            price: 12428000,
            img: "/packages/hilook/paket16-hilook2mp.png",
            features: [
              "10 pcs Indoor Hilook THC-T120-PC",
              "6 pcs Outdoor Hilook THC-B120-PC",
              "1 pcs DVR 16 Channel Hilook 216G-K1(s)",
              "1 pcs Hardisk WD Purple 2 Tera",
              "1 pcs PSU 12 Volt 30 Amp",
              "Max. 500 mtr Kabel RG 59",
              "32 pcs Konektor BNC",
              "16 pcs Konektor DC",
              "1 pcs Kabel HDMI",
              "1 pcs Stop Kontak",
              "1 pcs UTP Pendek",
              "6 bks Klem No.9",
              "10 bks Klem No.12",
              "2 bks Klem No.17",
              "2 bks Kabel Ties",
              "Kabel Duct 40 x 40",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
    ],
  },

  {
    brand: "EZVIZ",
    slug: "ezviz",
    logo: "/brands/ezviz.png",
    cover: "/packages/ezviz/cover.jpg",
    summary: "Kamera smart Wi-Fi untuk rumah, instalasi cepat & cloud ready.",
    startFrom: 2799000,
    categories: [
      {
        name: "WiFi IP Camera  + Pasang - Garansi 1 Tahun",
        slug: "wifi-ip-camera",
        theme: "red",
        items: [
          {
            title: "Wifi Camera EZVIZ H1C 2 MP",
            price: 700000,
            img: "/packages/ezviz/h1c2mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H1C 2MP",
              "1 pcs Micro SD Hiksemi 32 GB",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ H6C Pro 2 MP",
            price: 800000,
            img: "/packages/ezviz/h6c2mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H6C Pro 2MP",
              "1 pcs Micro SD Hiksemi 32 GB",
              "1 pcs Bracket Babycam",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ H6C Pro 4 MP",
            price: 1000000,
            img: "/packages/ezviz/h6c4mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H6C Pro 4 MP",
              "1 pcs Micro SD Hiksemi 64 GB",
              "1 pcs Bracket Babycam",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ H8C 2 MP",
            price: 1100000,
            img: "/packages/ezviz/h8c2mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H8C 2 MP",
              "1 pcs Micro SD Hiksemi 32 GB",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ H8C 4 MP",
            price: 1250000,
            img: "/packages/ezviz/h8c4mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H8C 4 MP",
              "1 pcs Micro SD Hiksemi 64 GB",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ EB8 4G + Solar Panel",
            price: 3500000,
            img: "/packages/ezviz/eb84g.png",
            features: [
              "1 pcs IP Camera EZVIZ EB8 4G + Solar Panel",
              "1 pcs Micro SD Hiksemi 64 GB",
              "1 pcs Kartu SIM GSM",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ H7C 4 MP",
            price: 1300000,
            img: "/packages/ezviz/h7c4mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H7C 4 MP",
              "1 pcs Micro SD Hiksemi 64 GB",
              "1 pcs Bracket Babycam",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi Camera EZVIZ H9C 3 MP",
            price: 1700000,
            img: "/packages/ezviz/h9c3mp.png",
            features: [
              "1 pcs IP Camera EZVIZ H9C 3 MP",
              "1 pcs Micro SD Hiksemi 64 GB",
              "1 pcs Bracket Babycam",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Wifi NVR 8 Channel Ezviz X5S 8W",
            price: 1950000,
            img: "/packages/ezviz/x5s8w.png",
            features: [
              "1 pcs Wifi NVR Ezviz X5S 8W",
              "1 pcs Hardisk WD Purple 1 Tera",
              "1 pcs Kabel HDMI 1.2 Meter",
              "2 pcs Konektor RJ 45",
              "5 mtr Kabel UTP CAT 6",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Router Hikvision DS-3WR3N",
            price: 550000,
            img: "/packages/ezviz/ds3wr3n.png",
            features: [
              "1 pcs Router Hikvision DS-3WR3N",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Router Hikvision DS-3WR12C",
            price: 650000,
            img: "/packages/ezviz/ds3wr12c.png",
            features: [
              "1 pcs Router Hikvision DS-3WR12C",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
          {
            title: "Router GSM Telkomsel Orbit Star G1",
            price: 750000,
            img: "/packages/ezviz/gsmtel.png",
            features: [
              "1 pcs Router GSM Telkomsel Orbit Star G1",
              "1 pcs Kartu SIM Orbit 150 GB",
              "1 pcs Steker Matsui",
              "1 pcs Stop Kontak 1 lubang",
              "5 Meter Kabel Listrik",
              "Pemasangan",
              "Setting Online",
            ],
          },
        ],
      },
    ],
  },
];

export default packages;
